<template>
  <div>
    {{ this.hnChang }}
    <b-alert
      show
      variant="dark"
      class="margin-bottom font12px icon-dark-custom"
      v-if="this.TmpDocGroup"
    >
      <h6 class="font-color-white1">Document Scan IPD</h6>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab
            :title="item.documentGroupNames"
            v-for="item in this.TmpDocGroup"
            v-bind:key="item.id"
          >
            <div
              style="margin:4px;"
              v-for="(item2, index2) in item.documentGroupScans"
              v-bind:key="item2.id"
            >
              <b-badge
                v-if="item2.scan_file_delete_status != 'Y'"
                variant="info"
                href="#"
                class="font12px"
                style="margin-left:8px;margin-buttom:4px;"
                @click="
                  viewDocScans(
                    item2.hn,
                    item2.an,
                    item2.scan_ipd_card_type,
                    item2.scan_ipd_card_datetime,
                    item2.scan_ipd_card_file_name
                  )
                "
                >{{ index2 + 1 }}. Scan :
                {{
                  thaiDatetimeFc.ThaiDateTime(item2.scan_ipd_card_datetime)
                }}</b-badge
              >
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <!-- 
      <div>
        <div v-for="(item, index) in this.TmpDocGroup" v-bind:key="item.id">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-badge
              variant="primary"
              href="#"
              v-b-toggle="'D' + index"
              class="font12px"
              >{{ item.documentGroupNames }}</b-badge
            >
          </b-card-header>
          <b-collapse
            :id="'D' + index"
            accordion="my-accordion"
            role="tabpanel"
          >
            <div
              style="margin:4px;"
              v-for="(item2, index2) in item.documentGroupScans"
              v-bind:key="item2.id"
            >
              <b-badge
                v-if="item2.scan_file_delete_status != 'Y'"
                variant="info"
                href="#"
                class="font12px"
                style="margin-left:8px;margin-buttom:4px;"
                @click="
                  viewDocScans(
                    item2.hn,
                    item2.scan_opd_card_type,
                    item2.scan_opd_card_datetime,
                    item2.scan_opd_card_file_name
                  )
                "
                >{{ index2 + 1 }}. Scan :
                {{ item2.scan_opd_card_datetime }}</b-badge
              >
            </div>
          </b-collapse>
        </div>
      </div>-->
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DocumentScanIPD from "@/models/patientEMRs/DocumentScanIPD";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpDocGroup: null,
      TmpDocData: null,
      TmpLocation: null,
      ptHN: "",
      ptAN: ""
    };
  },
  props: ["MyHn","MyAn"],
  component: {
    thaiDatetime,
    pjFunctions,
    DocumentScanIPD
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    this.hnChang;
  },
  watch: {
    ptHN: function() {
      this.getDocGroup(this.ptHN, this.ptAN);
    },
    ptAN: function() {
      this.getDocGroup(this.ptHN, this.ptAN);
    }
  },
  computed: {
    hnChang() {
      this.ptHN = this.MyHn;
      this.ptAN = this.MyAn;
    }
  },
  methods: {
    viewDocScans(
      hn,
      an,
      scan_ipd_card_type,
      scan_ipd_card_datetime,
      scan_ipd_card_file_name
    ) {
      let UrlApi = this.$store.get("systems@UrlApi");

      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DocumentScanViewIPD", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          an: an,
          scan_opd_card_type: scan_ipd_card_type,
          scan_opd_card_datetime: scan_ipd_card_datetime,
          scan_opd_card_file_name: scan_ipd_card_file_name,
          scan_opd_card_view_on_host: this.$store.get("systems@UrlApi"),
          scan_opd_card_view_on_software: "PjHIS"
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            let pdf =
              UrlApi +
              "charge_scan_view/" +
              ScrObj.output.result.documentScanFullPaths;

            window.open(pdf);
            /*
              var objbuilder = '';
              objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
              objbuilder += (ScrObj.output.result.documentScanFiles);
              objbuilder += ('" type="application/pdf" class="internal">');
              objbuilder += ('<embed src="data:application/pdf;base64,');
              objbuilder += (ScrObj.output.result.documentScanFiles);
              objbuilder += ('" type="application/pdf"  />');
              objbuilder += ('</object>');

              var win = window.open("#","_blank");
              var title = scan_opd_card_file_name;
              win.document.write('<html><title>'+ title +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
              win.document.write(objbuilder);
              win.document.write('</body></html>');
              win.document.write(image.outerHTML);*/
            /*
              layer = jQuery(win.document);
              */
          } else {
            console.log("DocumentScanIPDView : " + ScrObj.output.ErrorMessage);
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("DocumentScanIPDView : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.DataCh = "DocumentScanIPDView" + scan_ipd_card_file_name;
        });
    },
    getDocGroup(hn,an) {
      let ScrObj = DocumentScanIPD.query()
        .where(record => record.hn == hn)
        .where(record => record.an == an)
        .get()[0];

      if (ScrObj) {
        if (ScrObj.documentGroups.length > 0) {
          this.TmpDocGroup = ScrObj.documentGroups;
        } else {
          this.TmpDocGroup = null;
        }
      }
    },
    getDocScans(DocGroup) {
      let ScrObj = DocumentScanIPD.query()
        .where(
          record => record.documentScans.scan_ipd_card_type_name == DocGroup
        )
        .get();

      // console.log(ScrObj)
      if (ScrObj) {
        return ScrObj;
      } else {
        return null;
      }
    }
  }
})
export default class EmrDocumentScanIPD extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}
</style>

